import { toast } from 'react-toastify';

import { DEFAULT_TOAST_AUTOCLOSE_TIME } from '../constants/constants';

const info = (message, options) => {
    return toast.info(message, { autoClose: DEFAULT_TOAST_AUTOCLOSE_TIME, ...options });
};

const error = (message, options) => {
    return toast.error(message, { autoClose: DEFAULT_TOAST_AUTOCLOSE_TIME, ...options });
};

const success = (message, options) => {
    return toast.success(message, { autoClose: DEFAULT_TOAST_AUTOCLOSE_TIME, ...options });
};

const warn = (message, options) => {
    return toast.warn(message, { autoClose: DEFAULT_TOAST_AUTOCLOSE_TIME, ...options });
};

const dismiss = (id) => {
    return toast.dismiss(id);
};

export default {
    info,
    error,
    success,
    warn,
    dismiss
};
